import { render } from "./PopupLigaForumTest.vue?vue&type=template&id=71f4fae0"
import script from "./PopupLigaForumTest.vue?vue&type=script&lang=js"
export * from "./PopupLigaForumTest.vue?vue&type=script&lang=js"

import "./PopupLigaForumTest.vue?vue&type=style&index=0&id=71f4fae0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__